import { useS4LContext } from '@s4l/react-context'
import { getTaxTranslationKey, isKnownTaxType } from './utils'

export const usePriceDetailsHelpers = () => {
  const { i18n } = useS4LContext()

  const getTaxDisplayName = (taxName: string): string => {
    if (isKnownTaxType(taxName)) {
      const translationKey = getTaxTranslationKey(taxName)
      return i18n.formatMessage({ id: translationKey })
    }

    // Fallback for unknown tax types
    return taxName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
  }

  const formatCurrency = (amount?: number, currency?: string) => {
    if (!amount || !currency) return null

    return i18n.formatNumber(amount, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })
  }

  const formatMessageCapitalized = (
    message: { id: string },
    values?: Record<string, string | number | undefined>
  ) => {
    const text = i18n.formatMessage(message, values)
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
  }

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString)
    return i18n.formatDate(date, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  return {
    getTaxDisplayName,
    formatCurrency,
    formatMessage: i18n.formatMessage,
    formatMessageCapitalized,
    formatDate,
  }
}
